export default {
  unauthorizedAdmin: [],
  admin: [
    {
      path: 'debug/video',
      name: 'admin.debug-video',
      component: () => import('modules/debug/views/admin/video.vue'),
    },
    {
      path: 'debug/ga-report',
      name: 'admin.debug-ga-report',
      component: () => import('modules/debug/views/admin/report.vue'),
    },
    {
      path: 'debug/permission',
      name: 'admin.debug-permission',
      component: () => import('modules/debug/views/admin/permission.vue'),
    },
    {
      path: 'debug/broadcast',
      name: 'admin.debug-broadcast',
      component: () => import('modules/debug/views/admin/broadcast.vue'),
    },
    {
      path: 'debug/notification',
      name: 'admin.debug-notification',
      component: () => import('modules/debug/views/admin/notificationApi.vue'),
    },
  ],
}